<template>
  <div>
    <v-card class="d-flex align-start px-2 py-4" :to="{ name: 'Sponsor', params: { id } }" elevation="0" tile>
      <v-img :src="cover_image" max-width="80px" contain v-if="cover_image !== ''"></v-img>
      <v-img src="@/assets/sponsor-placeholder.png" max-width="80px" contain v-else></v-img>
      <div class="ml-2">
        <div>{{ name_zh }}</div>
        <div class="mt-1">{{ name_en }}</div>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "SponsorCard",
  props: {
    id: {
      type: Number,
      required: true
    },
    cover_image: {
      type: String
    },
    name_en: {
      type: String
    },
    name_zh: {
      type: String
    },
    products: {
      type: Array
    }
  }
};
</script>

<style></style>
